import Vue from "vue";
import api from "@/api";
import getLocale from "@/utils/locale";

const state = {
  promotion: null
};

const mutations = {
  promotion: (state, payload) => {
    Vue.set(state, "promotion", payload);
  }
};

const getters = {
  activePromotionName: (state) => {
    return state.promotion && state.promotion.name;
  },
  content: (state) => {
    if (!state.promotion) {
      return;
    }

    const body = state.promotion[`body_copy_${getLocale()}`].trim();
    const link = state.promotion[`link_copy_${getLocale()}`].trim();
    const href = state.promotion[`href_${getLocale()}`].trim();
    return `${body} <a href="${href}">${link}</a>`;
  },
  cookie: (state) => {
    if (!state.promotion) {
      return;
    }
    var endDate = new Date(state.promotion.end_date);

    // Add one day to lifetime to make sure cookie doesn't expire before the
    // sale ends, showing the same user the banner twice.
    return Math.ceil((endDate - new Date()) / 1000 / 60 / 60 / 24) + 1;
  }
};

const actions = {
  load: ({ commit, rootState }, doc) => {
    if (!isPageAllowed(doc)) {
      return;
    }

    api.promotions("web", rootState.user.segment)
      .then(data => {
        commit("promotion", data.promotion);
      })
      .catch(() => { /* No UI feedback on error */ });
  }
};

const isPageAllowed = (doc) => {
  const selectors = [
    "body.landing_pages__show",
    "body.partner_pages__show",
    "body.top_books__show",
    "body.daily__show"
  ];
  return !selectors.find(a => doc.querySelector(a));
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
